import Vue from 'vue'
import VueRouter from 'vue-router'
import BaiDu from "@/views/BaiDu"
import BaiDu02 from "@/views/components/BaiDu02.vue"
import changeSeason from "@/views/ChangeSeasons/ChangeSeason.vue";
import Spring from "@/views/ChangeSeasons/components/Spring.vue";
import Summer from "@/views/ChangeSeasons/components/Summer.vue";
import Autumn from "@/views/ChangeSeasons/components/Autumn.vue";
import Winter from "@/views/ChangeSeasons/components/Winter.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'BaiDu',
    component: BaiDu
  },
  {
  path: '/BaiDu02',
    name: 'BaiDu02',
    component: BaiDu02
  },
  {
    path: '/ChangeSeason',
    name:'ChangeSeason',
    component: changeSeason,
    children:[
      {
        path:'Spring',
        name:'Spring',
        component:Spring,
      },
      {
        path:'Summer',
        name:'Summer',
        component:Summer,
      },
      {
        path:'Autumn',
        name:'Autumn',
        component:Autumn,
      },
      {
        path:'Winter',
        name:'Winter',
        component:Winter,
      },
    ]
  }

]

const router = new VueRouter({
  routes
})

export default router
